import { jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { getZombieInstanceFromPrimaryKey } from '@iotv/datamodel-core';
import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { getOne } from '../../data/daoFunctions/daoFunctions';
import { extractViewObjectFromNodeEdgeMapper } from '../../data/daoFunctions/nodeEdgeMapperTransform';
import { NavSections } from '../navigation/NavSections';
const DEV = process.env.REACT_APP_DEBUG;
const debug = DEV && false;
/** @deprecated use `ThingView` via the `ThingViewMap` instead! */
function AdminView(props) {
    const { contextObject, userFunctions, applicationData } = props;
    debug && console.log(`AdminRedirectView rerendering`);
    const { id, type } = useParams();
    const [item, setItem] = useState();
    const [isGroup, setIsGroup] = useState(type === 'Group');
    const [viewObject, setViewObject] = useState({ matchedPrimary: contextObject, matchedRelatedByPk: [], matchedRelatedBySk: [] });
    const getNotInStateObject = async (object) => {
        const itemRes = await getOne(object);
        debug && console.log('AdminRedirectView getNotInStateObject', itemRes);
        if (itemRes.data) {
            userFunctions.addObjectsToState([itemRes.data]);
        }
        else {
            debug && console.log('AdminRedirectView item res no data returned');
        }
        return itemRes.data || undefined;
    };
    useEffect(() => {
        debug && console.log(`AdminRedirectView used effect on`, { type, id, sk: contextObject?.sk });
        const doThing = async () => {
            const subjectItem = contextObject || (await getNotInStateObject(getZombieInstanceFromPrimaryKey(`${type}:${id}`)));
            debug && console.log(`AdminRedirectView subjectItem ${subjectItem?.sk}`);
            if (subjectItem === undefined)
                return;
            setItem(subjectItem);
            setIsGroup(subjectItem.type === 'Group');
            if (applicationData) {
                setViewObject(extractViewObjectFromNodeEdgeMapper(applicationData, subjectItem));
                debug && console.log(`AdminRedirectView applicationData items ${applicationData.countItems()}`, viewObject);
            }
        };
        if ((type && id) || contextObject?.sk)
            doThing();
    }, [type, id, contextObject?.sk, applicationData]);
    let toReturn = DEV ? _jsxs(Typography, { children: [type, " redirect TBD"] }) : _jsx(_Fragment, {});
    if (isGroup) {
        if (type !== undefined && id !== undefined && item?.supportedType !== undefined) {
            toReturn = _jsx(Navigate, { to: `/${NavSections.THINGVIEW}/${type}/${id}`, replace: true });
        }
    }
    else {
        switch (type) {
            default:
                if (type !== undefined)
                    toReturn = _jsx(Navigate, { to: `/${NavSections.THINGVIEW}/${type}/${id}`, replace: true });
        }
    }
    return toReturn;
}
/** @deprecated use `ThingView` via the `ThingViewMap` instead! */
export default AdminView;
